const STATUS_CONFIG: Record<string, { bg: string; text: string; label: string }> = {
  pending:   { bg: '#fef3c7', text: '#d97706', label: 'En attente' },
  validated: { bg: '#dcfce7', text: '#16a34a', label: 'Validé' },
  rejected:  { bg: '#fee2e2', text: '#dc2626', label: 'Refusé' },
  draft:     { bg: '#f1f5f9', text: '#64748b', label: 'Brouillon' },
  sent:      { bg: '#dbeafe', text: '#2563eb', label: 'Envoyé' },
  paid:      { bg: '#dcfce7', text: '#16a34a', label: 'Payé' },
  overdue:   { bg: '#fee2e2', text: '#dc2626', label: 'En retard' },
  received:  { bg: '#dcfce7', text: '#16a34a', label: 'Reçu' },
  cancelled: { bg: '#f1f5f9', text: '#64748b', label: 'Annulé' },
  published: { bg: '#dbeafe', text: '#2563eb', label: 'Publié' },
};

interface StatusBadgeProps {
  status: string;
  label?: string;
  size?: 'sm' | 'md';
}

export function StatusBadge({ status, label, size = 'sm' }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status] || { bg: '#f1f5f9', text: '#64748b', label: status };
  const displayLabel = label || config.label;

  const isSmall = size === 'sm';

  return (
    <span style={{
      display: 'inline-block',
      background: config.bg,
      color: config.text,
      padding: isSmall ? '2px 8px' : '4px 12px',
      borderRadius: '6px',
      fontSize: isSmall ? '0.75rem' : '0.85rem',
      fontWeight: 600,
      whiteSpace: 'nowrap',
    }}>
      {displayLabel}
    </span>
  );
}
